module.exports = __webpack_public_path__ + "img/ogp_corp.f251e8f2.png";